import React from "react";
import "./Overview.css";

const Overview = ({ stats }) => (
  <div className="admin-overview">
    <div className="stats-grid">
      <div className="stat-card">
        <div className="stat-icon">👥</div>
        <div className="stat-content">
          <h3>{stats.totalUsers}</h3>
          <p>Total Users</p>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon">📊</div>
        <div className="stat-content">
          <h3>{stats.totalPresentations}</h3>
          <p>Total Presentations</p>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon">🟢</div>
        <div className="stat-content">
          <h3>{stats.activeUsers}</h3>
          <p>Active Users</p>
        </div>
      </div>
      <div className="stat-card">
        <div className="stat-icon">⚡</div>
        <div className="stat-content">
          <h3>{stats.systemHealth}</h3>
          <p>System Status</p>
        </div>
      </div>
    </div>

    {/* <div className="recent-activity">
      <h3>Recent Activity</h3>
      <div className="activity-list">
        <div className="activity-item">
          <span className="activity-time">2 hours ago</span>
          <span className="activity-text">
            New user registration: john.doe@law.com
          </span>
        </div>
        <div className="activity-item">
          <span className="activity-time">4 hours ago</span>
          <span className="activity-text">
            Presentation uploaded: Contract Analysis Q3
          </span>
        </div>
        <div className="activity-item">
          <span className="activity-time">6 hours ago</span>
          <span className="activity-text">
            User role updated: jane.smith@law.com
          </span>
        </div>
      </div>
    </div> */}
  </div>
);

export default Overview;
